<template>
  <span v-if="evat && evat.status" class="evat-status-chip">
    <v-tooltip
      v-if="isFailed"
      bottom
      max-width="360"
      content-class="evat-status-tooltip"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          x-small
          class="evat-status-chip__item evat-status-chip__item--clickable"
          :color="statusColor"
          :text-color="statusTextColor"
          label
          @click="openSubmissions"
        >
          {{ statusLabel }}
        </v-chip>
      </template>
      <span>{{ failureTooltip }}</span>
    </v-tooltip>

    <v-chip
      v-else
      x-small
      class="evat-status-chip__item"
      :color="statusColor"
      :text-color="statusTextColor"
      label
    >
      <v-progress-circular
        v-if="evat.status === 'submitting'"
        indeterminate
        size="10"
        width="2"
        class="mr-1"
      ></v-progress-circular>
      {{ statusLabel }}
    </v-chip>

    <v-chip
      v-if="evat.is_verified"
      x-small
      class="evat-status-chip__item"
      color="green lighten-4"
      text-color="green darken-3"
      label
    >
      Verified
    </v-chip>
  </span>
</template>

<script>
import { EVAT_STATUS_LABELS } from "../../utils/evat";

export default {
  name: "EvatStatusChip",
  props: {
    evat: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isFailed() {
      return this.evat?.status === "failed";
    },
    statusLabel() {
      if (!this.evat?.status) return "";
      if (this.evat.status === "submitted") return "Submitted to GRA";
      if (this.evat.status === "failed") return "GRA submission failed";
      return EVAT_STATUS_LABELS[this.evat.status] || this.evat.status;
    },
    failureTooltip() {
      const message =
        this.evat?.error_message ||
        this.evat?.message ||
        this.evat?.error;
      if (message) return message;
      return "This document could not be submitted to GRA. Use Retry submission to try again, or check the E-VAT submissions list for details.";
    },
    statusColor() {
      const map = {
        draft: "grey lighten-3",
        submitting: "blue lighten-4",
        submitted: "green lighten-4",
        failed: "red lighten-4",
      };
      return map[this.evat.status] || "grey lighten-3";
    },
    statusTextColor() {
      const map = {
        draft: "grey darken-2",
        submitting: "blue darken-3",
        submitted: "green darken-3",
        failed: "red darken-3",
      };
      return map[this.evat.status] || "grey darken-2";
    },
  },
  methods: {
    openSubmissions() {
      const route = this.$router.resolve({ path: "/evat/submissions" });
      window.open(route.href, "_blank");
    },
  },
};
</script>

<style scoped>
.evat-status-chip {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  gap: 6px;
  height: 28px;
  line-height: 1;
}

.evat-status-chip__item {
  margin: 0 !important;
  height: 22px !important;
  cursor: default;
}

.evat-status-chip__item--clickable {
  cursor: pointer !important;
}
</style>
